/**
 * Describes the type of the delta being applied.
 */
export var TextTileDeltaType;
(function (TextTileDeltaType) {
    // Adds new content to the existing tile at the specified position
    TextTileDeltaType[TextTileDeltaType["Add"] = 0] = "Add";
    // Deletes content from the existing tile at the specified position
    TextTileDeltaType[TextTileDeltaType["Delete"] = 1] = "Delete";
    // Updates the content of the existing tile at the specified position
    TextTileDeltaType[TextTileDeltaType["Update"] = 2] = "Update";
    // Updates additional properties without content changes of the existing tiles, updates are related to IPPosition and isColdIp properties
    TextTileDeltaType[TextTileDeltaType["CursorUpdate"] = 3] = "CursorUpdate";
    // Updates additional properties without content changes of the existing tiles, updates are related to formattedRanges property
    TextTileDeltaType[TextTileDeltaType["FormattingUpdate"] = 4] = "FormattingUpdate";
    // Updates additional properties without content changes of the existing tiles, updates are related to:
    // indentation, outlineLevel, listType, alignment, isInsideTable, isInsideTOC, objectReferences, spacingBeforeParagraph
    // spacingAfterParagraph, lineSpacing, rightIndentation, listId, bulletAndNumberFontSize, bulletAndNumberFontFamily, specialIndentType, specialIndentBy
    // fontKerning, queryRange properties
    TextTileDeltaType[TextTileDeltaType["OtherNonContentUpdate"] = 5] = "OtherNonContentUpdate";
})(TextTileDeltaType || (TextTileDeltaType = {}));
/**
 * The unit on which this delta is operating.
 */
export var TextTileDeltaUnit;
(function (TextTileDeltaUnit) {
    // Character level changes of no semantic meaning on their own.
    TextTileDeltaUnit[TextTileDeltaUnit["Chars"] = 0] = "Chars";
    // Adding/deleting/updating a single word.
    TextTileDeltaUnit[TextTileDeltaUnit["Word"] = 1] = "Word";
    // Adding/deleting/updating a part of a sentence.
    TextTileDeltaUnit[TextTileDeltaUnit["PartialSentence"] = 2] = "PartialSentence";
    // Adding/deleting/updating a full sentence.
    TextTileDeltaUnit[TextTileDeltaUnit["Sentence"] = 3] = "Sentence";
    // Adding/deleting/updating a full or partial paragraph.
    TextTileDeltaUnit[TextTileDeltaUnit["Paragraph"] = 4] = "Paragraph";
})(TextTileDeltaUnit || (TextTileDeltaUnit = {}));
export var TextTileChangeSource;
(function (TextTileChangeSource) {
    TextTileChangeSource[TextTileChangeSource["SessionUser"] = 0] = "SessionUser";
    TextTileChangeSource[TextTileChangeSource["Programmatic"] = 1] = "Programmatic";
    TextTileChangeSource[TextTileChangeSource["Collaborator"] = 2] = "Collaborator";
})(TextTileChangeSource || (TextTileChangeSource = {}));
//# sourceMappingURL=deltas.js.map